import usePostDraft, { DraftType } from '@/utils/hooks/usePostDraft'
import { debounce } from 'lodash-es'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import type { PostFormValue } from './PostForm/schemas'
import { RepostFormValue } from './RepostForm/types'

export default function AutoSaveService({ type }: { type: DraftType }) {
	const { subscribe } = useFormContext()
	const [, setDraft] = usePostDraft(type)

	useEffect(() => {
		const debouncedSetDraft = debounce((data: PostFormValue | RepostFormValue) => {
			setDraft(data)
		}, 300)

		const unsubscribe = subscribe({
			formState: { values: true },
			callback: ({ values }) => {
				debouncedSetDraft(values as PostFormValue | RepostFormValue)
			},
		})

		return () => {
			debouncedSetDraft.flush()
			unsubscribe()
		}
	}, [setDraft, subscribe])

	return null
}
